module.exports = __webpack_public_path__ + "img/logo_customer.f479e890.png";